import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { qmsService } from 'src/app/qms/qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { PopupData } from 'src/app/users/users.component';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { messageService } from 'src/app/message.service';


@Component({
  selector: 'app-scheduled-training-details',
  templateUrl: './scheduled-training-details.component.html',
  styleUrls: ['./scheduled-training-details.component.scss']
})
export class ScheduledTrainingDetailsComponent implements OnInit {

  scheduleTrainingFieldData: any = {};
  openSnackbar: any;
  errorStatus: any;
  isProcessing = false;
  buttonLabels: any = [];
  instructions: any;
  saveButtonForScheduleTraining: boolean = false;
  dropDownForMode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  isShowTrainingAssessmentFlag: boolean;
  scheduleUsersList: any = [];
  trainingShceduleId: any;
  feedbackTemplateList: any = [];
  modeSearchText: string = '';
  templateSearchText: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';
  approverSearchText: string = '';
  individualReport: boolean = false;
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  }
  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  dateTimePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    withTimepicker: true,
    useSeconds: true,
    keepDatepickerOpened: true,
  }

  dateTimePickerConfigurationForExpired = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    withTimepicker: true,
    keepDatepickerOpened: true,
    minDate: new Date()
  }
  dateCustomClasses: DatepickerDateCustomClasses[];
  isAdenabled: boolean = false;

  isShowIcons: any;
  constructor(public appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public qmsservice: qmsService,
    public paginationService: PaginationService, public message: messageService, public dialog: MatDialog, private readonly authService: MsalService, public datePipe: DatePipe) {
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.isShowTrainingAssessmentFlag = data['isShowTakeAssessmentField'];
    this.trainingShceduleId = data['trainingScheduleId'];
    this.feedbackTemplateList = data['feedbackTemplateList'];
    this.appService.getNonOrgCodeListsByGroupName("TRAINING_MODE").subscribe((data: any) => {
      this.dropDownForMode = data;
      this.selectBoxeForMode();
      this.getInitCall();
    })
  }

  userId: any;
  approverDropdown: any = [];
  isShowAddUser = false;
  displayUserName: any;

  ngOnInit(): void {
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;

    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';

    this.isProcessing = true;
    this.appService.getTrainingScheduleUsers(this.trainingShceduleId)
      .subscribe((data: any) => {
        this.isProcessing = false;
        const userTimezone = localStorage.getItem('timezone') || 'Asia/Kolkata';
        this.scheduleUsersList = data;
        this.collectionSize = this.scheduleUsersList.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0,);
      })
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();

    this.appService.getInstructorApprovers().subscribe({
      next: (data: any) => {
        const activeApprovers = data
          .filter((user: any) => user.isActive === 'Y')
          .map((user: any) => ({
            valueExp: user.userId,
            displayExp: user.userFullname
          }));

        this.approverDropdown.push(...activeApprovers);
      }, error: (error) => {
        this.isProcessing = false;
      }
    })
    this.dynamicLabelCall();
    this.ngOnChangesReportFooter();
  }

  isOddApprover: any = null;
  isButtonClicked: boolean = false;

  toggleButtonShadow() {
    this.isButtonClicked = !this.isButtonClicked;
  }

  getInitCall() {
    this.isProcessing = true;
    this.appService.getScheduledTrainingById(this.trainingShceduleId).subscribe((response: any) => {
      this.scheduleTrainingFieldData = response[0];
      this.isProcessing = false;
      this.scheduleTrainingFieldData.isShowTrainingAssessmentFlag = this.isShowTrainingAssessmentFlag;
      this.scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication = this.scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication == "Y";
      this.scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 = this.scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication;

    if (this.scheduleTrainingFieldData.scheduledStartDate != null) {
        this.scheduleTrainingFieldData.scheduledStartDate = new Date(this.scheduleTrainingFieldData.scheduledStartDate);
      }
      if (this.scheduleTrainingFieldData.scheduledEndDate != null) {
        this.scheduleTrainingFieldData.scheduledEndDate = new Date(this.scheduleTrainingFieldData.scheduledEndDate);
      }
      if (this.scheduleTrainingFieldData.expiredOn != null) {
        this.scheduleTrainingFieldData.expiredOn = new Date(this.scheduleTrainingFieldData.expiredOn);
      }
      if (this.scheduleTrainingFieldData.actualStartDate != null) {
        this.scheduleTrainingFieldData.actualStartDate = new Date(this.scheduleTrainingFieldData.actualStartDate);
      }
      if (this.scheduleTrainingFieldData.actualEndDate != null) {
        this.scheduleTrainingFieldData.actualEndDate = new Date(this.scheduleTrainingFieldData.actualEndDate);
      }
      if (this.scheduleTrainingFieldData.initiatedOn != null) {
        this.scheduleTrainingFieldData.initiatedOn = new Date(this.scheduleTrainingFieldData.initiatedOn);
      }
      if (this.scheduleTrainingFieldData.feedbackCompletedOn != null) {
        this.scheduleTrainingFieldData.feedbackCompletedOn = new Date(this.scheduleTrainingFieldData.feedbackCompletedOn);
      }
      if (this.scheduleTrainingFieldData.approvalRequestedOn != null) {
        this.scheduleTrainingFieldData.approvalRequestedOn = new Date(this.scheduleTrainingFieldData.approvalRequestedOn);
      }
      if (this.scheduleTrainingFieldData.approvedOn != null) {
        this.scheduleTrainingFieldData.approvedOn = new Date(this.scheduleTrainingFieldData.approvedOn);
      }
      this.selectedTrainingModeValue = this.scheduleTrainingFieldData.trainingMode;

      if (this.scheduleTrainingFieldData.approvedBy) {
        const matchingApprover = this.approverDropdown.find((x: any) => x.valueExp === this.scheduleTrainingFieldData.approvedBy);

        if (matchingApprover) {
          this.isOddApprover = null;
        } else {
          this.isOddApprover = this.scheduleTrainingFieldData.approvedBy;
          this.approverDropdown.push({
            valueExp: this.scheduleTrainingFieldData.approvedBy,
            displayExp: this.scheduleTrainingFieldData.approvedByUser
          });
        }

        this.message.scheduledTrainingsApprover = this.scheduleTrainingFieldData.approvedBy;
      }

      this.message.scheduledTrainingsApprover = this.scheduleTrainingFieldData.approvedBy;
      if (this.scheduleTrainingFieldData.trainingMode) {
        this.selectedTrainingMode = this.scheduleTrainingFieldData.trainingMode;
      }
      this.userId = this.message.getUserId()
      if (this.scheduleTrainingFieldData.trainerId == this.userId || this.scheduleTrainingFieldData.createdBy == this.userId ||
        this.scheduleTrainingFieldData.updatedBy == this.userId) {
        this.isShowAddUser = true;
      } else {
        this.isShowAddUser = false;
      }
      this.appService.getContentsList(this.scheduleTrainingFieldData.trainingId,
        this.scheduleTrainingFieldData.version).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.some((item: any) => item.isQuestionContent === 'Y')) {
            this.isShowTrainingAssessmentFlag = true;
          }
        })
      this.selectedTrainingModeValue = this.scheduleTrainingFieldData.trainingMode;
      if (this.message.getUserId() == this.scheduleTrainingFieldData.trainerId) {
        this.isShowIcons = true;
      } else {
        this.isShowIcons = false;
      }
      this.saveButtonForScheduleTraining = false;
      let data = {
        trainingScheduleId: this.scheduleTrainingFieldData.trainingScheduleId,
        status: this.scheduleTrainingFieldData.status
      }
      this.appService.getButtonLabelsForScheduleTraining(data).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.instructions = data.instructions;
          if (data.buttonLabels != null) {
            this.buttonLabels = data.buttonLabels.split(",");
            for (let i = 0; i < this.buttonLabels.length; i++) {
              if (this.buttonLabels[i] == "Save") {
                this.saveButtonForScheduleTraining = true;

              }
              if (this.buttonLabels[i] == "Cancel") {
                this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Cancel" });
                i--;
              }
            }

          }
        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: data.resultType == 'S' ? 5000 : undefined,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }

      })
    })

  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  @ViewChild('addUserPopup', { static: true }) addUserPopup: TemplateRef<any>;
  @ViewChild('operationPopup', { static: true }) operationPopup: TemplateRef<any>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;
  @ViewChild('bulkOperationPopup', { static: true }) bulkOperationPopup: TemplateRef<any>;
  @ViewChild('initiateFeedbackPopup', { static: true }) initiateFeedbackPopup: TemplateRef<any>;
  @ViewChild('feedbackDetailPopup', { static: true }) feedbackDetailPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddUserPopup: MatDialogRef<TemplateRef<any>>;
  visibleOperationPopup: MatDialogRef<TemplateRef<any>>;
  visibleConfirmPopup: MatDialogRef<TemplateRef<any>>;
  visibleBulkOperationPopup: MatDialogRef<TemplateRef<any>>;
  visibleInitiateFeedbackPopup: MatDialogRef<TemplateRef<any>>;
  visibleFeedbackDetailPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reInitiateFeedbackPopup', { static: true }) reInitiateFeedbackPopup: TemplateRef<any>;
  visibleReInitiateFeedbackPopup: MatDialogRef<TemplateRef<any>>;

  reInitiateFeedbackPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  searchUserConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addAndEditPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  initiateFeedbackPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  feedbackDetailPopupConfig = {
    width: '900px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  operationConfig = {
    width: '650px',
    height: 'auto',
    hasBackdrop: true,
    position: { top: '30px' },
    disableClose: true,
  };

  bulkOperationConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  confirmConfig = {
    width: '700px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addUserConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;

  searchUserDataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.getOneQmsUsersVwDetailsTableData.forEach((user: any) => {
      user.searchUserChildCheckBoxs = isChecked;
    });

    if (isChecked) {
      this.selectedUserIdList = this.getOneQmsUsersVwDetailsTableData.map((user: any) => user.userId);
      this.selectedUserNameList = this.getOneQmsUsersVwDetailsTableData.map((user: any) => user.userNameAtApplication);
    } else {
      this.selectedUserIdList = [];
      this.selectedUserNameList = [];
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;

  selectedUserIdList: any = [];
  selectedUserNameList: any = [];
  previousSelectedData: any = {};
  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;
      if (this.searchVal == "Trainer") {
        this.getSelectedUserId = listOfUsersVwDetails.userId;
        this.getSelectedUserName = listOfUsersVwDetails.userFullname;
        this.previousSelectedData.searchUserChildCheckBoxs = false;
      } else {
        this.selectedUserIdList.push(listOfUsersVwDetails.userId);
        this.selectedUserNameList.push(listOfUsersVwDetails.userFullname);
      }

    } else {
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      if (this.searchVal == "Trainer") {
        this.getSelectedUserId = null;
        this.getSelectedUserName = '';
      } else {
        this.selectedUserIdList.splice(this.selectedUserIdList.indexOf(listOfUsersVwDetails.userId), 1);
        this.selectedUserNameList.splice(this.selectedUserNameList.indexOf(listOfUsersVwDetails.userNameAtApplication), 1);
      }
    }
    this.previousSelectedData = listOfUsersVwDetails;
  }

  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  showUserSearchGrid = false;
  searchVal: any;
  isShowBulkIcons: boolean = false;
  searchMode: string = 'search';
  searchUserFunction(val: any, mode: string) {
    this.searchMode = mode;
    this.searchVal = val;
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.userList = null;
    this.userNameList = null;
    this.selectedUserIdList = [];
    this.selectedUserNameList = [];
    this.popupDataTitle.title = "Search " + val;
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);
  }
  userList: any = null;
  userNameList: any = null;
  canShowTrainerSwitchUser(): boolean {
    const status = this.scheduleTrainingFieldData.status;
    const allowedStatuses = ['Pending Approval', 'Scheduled', 'Assessment Inprogress'];
    return status && allowedStatuses.includes(status);
  }

  canEditTrainerField(): boolean {
    const status = this.scheduleTrainingFieldData?.status;
    const allowedStatuses = ['Draft', 'Approval Rejected'];
    return status && allowedStatuses.includes(status);
  }
  switchTrainerName() {
    // 1. Validation: Check if the selected user is the same as the current trainer
    if (this.getSelectedUserId === this.scheduleTrainingFieldData.trainerId) {
      this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: "Sorry! Can't switch to the same user",
          type: 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'Error',
      });
      return; // Stop execution
    }

    // 2. Prepare Switch User Component for Logging
    // We populate the shared message service so the SwitchUserComponent knows who is switching
    this.message.switchUserCurrentValue = this.scheduleTrainingFieldData.trainerId; // Old Trainer
    this.message.switchedUser = this.getSelectedUserId; // New Trainer
    this.message.activityId = this.scheduleTrainingFieldData.trainingScheduleId;
    this.switchuserComponent.switchUserRole = 'Trainer';
    this.switchuserComponent.switchPageName = 'Instructor Training';
    this.switchuserComponent.reasonForSwitch = 'Trainer switched via search grid';
    this.qmsservice.moduleName = 'Instructor Trainings'
    // 3. Update local UI data
    this.scheduleTrainingFieldData.trainerId = this.getSelectedUserId;
    this.scheduleTrainingFieldData.trainerName = this.getSelectedUserName;

    // 4. Trigger the Log Creation and the Save Operation
    this.visibleSearchUserPopup.close();

    // This creates the entry in the switch user log table
    this.switchuserComponent.saveMethod();

    // This updates the actual training record
    this.performSaveOperation();
  }
  addUserNameFunction() {
    if (this.searchVal == "Trainer") {
      this.scheduleTrainingFieldData.trainerId = this.getSelectedUserId;
      this.scheduleTrainingFieldData.trainerName = this.getSelectedUserName;
    } else {
      this.userList = this.selectedUserIdList.length > 0 ? this.selectedUserIdList.join(',') : null;

      this.userNameList = this.selectedUserNameList.length > 0 ? this.selectedUserNameList.join(',') : null;

      if (this.userList == null) {
        this.instructorUserValidation();
      } else {
        let data = {
          userList: this.userList,
          trainingMode: "ADD",
          trainingScheduleId: this.scheduleTrainingFieldData.trainingScheduleId
        }
        this.isProcessing = true;
        this.appService.handledScheduleUsers(data).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.isProcessing = true;
            this.appService.getTrainingScheduleUsers(this.scheduleTrainingFieldData.trainingScheduleId)
              .subscribe((data: any) => {
                this.isProcessing = false;
                this.scheduleUsersList = data;
                this.collectionSize = this.scheduleUsersList.length;
                this.pager.totalPages = undefined;
                this.setPage(1, 0,);
              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: data.resultType == 'S' ? 5000 : undefined,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        })
      }

    }

    this.visibleSearchUserPopup.close();
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction() {
    this.getOneQmsUsersVwDetailsTableData = [];
    this.isProcessing = true;

    this.designationCodeValue = this.searchByDesignationCode || null;
    this.departmentCodeValue = this.searchByDepartmentCode || null;

    const formattedUser = this.searchByUserName ? this.searchByUserName.toUpperCase() : "";
    this.searchOneQmsUserVwDetails = {
      userName: formattedUser,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      groupId: 0
    };
    if (this.searchVal == "Trainer") {
      this.appService.getTrainingsUsersList(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
        this.getOneQmsUsersVwDetailsTableData = [];
        const existingUserIds = new Set(this.scheduleUsersList?.map((item: any) => item.userId) || []);

        const newUsers = response.filter((resItem: any) => !existingUserIds.has(resItem.userId));

        this.getOneQmsUsersVwDetailsTableData.push(...newUsers);
        this.showUserSearchGrid = true;
        this.isProcessing = false;
      })
    } else {
      this.appService.searchUsersForInstructorTraining(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
        this.getOneQmsUsersVwDetailsTableData = [];
        const existingUserIds = new Set(this.scheduleUsersList?.map((item: any) => item.userId) || []);
        const trainerId = this.scheduleTrainingFieldData?.trainerId;

        const validUsers = response.filter((user: any) =>
          user.userId !== trainerId && !existingUserIds.has(user.userId)
        );
        this.getOneQmsUsersVwDetailsTableData.push(...validUsers);
        this.showUserSearchGrid = true;
        this.isProcessing = false;
      })
    }

  }

  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  selectBoxeForDesignationCode() {
    // .map() automatically loops through and returns the newly shaped array
    this.designationCodeDropdown = (this.dropDownForDesignationCode || []).map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  selectBoxeForDepartmentCode() {
    this.departmentCodeDropdown = (this.dropDownForDepartmentCode || []).map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  selectBoxeForMode() {
    const newModes = (this.dropDownForMode || []).map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));

    this.modeDropdown.push(...newModes);
  }
  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  modeDropdown: any = [];
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedDesignationValue = item.valueExp;
      } else {
        this.selectedDesignationValue = null;
      }
    }
  }

  onDesignationCodeSelectOld(item: any) {
    this.selectedDesignationValue = item.valueExp;
  }

  onDesignationCodeRemoved(item: any) { }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedDepartmentValue = item.valueExp;
      } else {
        this.selectedDepartmentValue = null;
      }
    }
  }

  onDepartmentCodeSelectOld(item: any) {
    this.selectedDepartmentValue = item.valueExp;
  }

  /*   onDepartmentCodeSelect(item: any) {

      this.selectedDepartmentValue = item.valueExp;
    } */
  onDepartmentCodeRemoved(item: any) { }

  selectedTrainingMode: any = null;
  selectedTrainingModeValue: any;

  onModeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedTrainingModeValue = item.valueExp;
      } else {
        this.selectedTrainingModeValue = null;
      }
    }
  }

  onTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      console.log(" ")
    }
  }

  onModeSelectOld(item: any) {
    this.selectedTrainingModeValue = item.valueExp;
  }

  onModeRemoved(item: any) {
    this.selectedTrainingModeValue = null;
  }

  back() {
    history.back();
  }

  trainingName: any;
  trainerId: any;
  scheduleStartDate: any;
  scheduleEndDate: any;
  mode: any;
  trainingNameRequiredMsg: any;
  trainerRequiredMsg: any;
  scheduleStartDateRequireMsg: any;
  scheduleEndDateRequireMsg: any
  modeRequiredMsg: any;

  fieldValidation() {

    this.trainerId = document.getElementById('userName') as HTMLInputElement;
    this.scheduleStartDate = document.getElementById('scheduleStartDate') as HTMLInputElement;
    this.scheduleEndDate = document.getElementById('scheduleEndDate') as HTMLInputElement;
    this.mode = document.getElementById('trainingMode') as HTMLInputElement;

    this.trainerRequiredMsg = document.getElementById('userName-required-msg') as HTMLInputElement;
    this.scheduleStartDateRequireMsg = document.getElementById('scheduleStartDate-required-msg') as HTMLInputElement;
    this.scheduleEndDateRequireMsg = document.getElementById('scheduleEndDate-required-msg') as HTMLInputElement;
    this.modeRequiredMsg = document.getElementById('trainingMode-required-msg') as HTMLInputElement;

    if (this.scheduleTrainingFieldData.trainerId == null) {
      this.trainerId.style.border = '1px solid red';
      this.trainerRequiredMsg.style.display = 'block';
    } else {
      this.trainerId.style.border = 'none';
      this.trainerRequiredMsg.style.display = 'none';
    }

    if (this.scheduleTrainingFieldData.scheduledStartDate == null) {
      this.scheduleStartDate.style.border = '1px solid red';
      this.scheduleStartDateRequireMsg.style.display = 'block';
    } else {
      this.scheduleStartDate.style.border = 'none';
      this.scheduleStartDateRequireMsg.style.display = 'none';
    }

    if (this.scheduleTrainingFieldData.scheduledEndDate == null) {
      this.scheduleEndDate.style.border = '1px solid red';
      this.scheduleEndDateRequireMsg.style.display = 'block';
    } else {
      this.scheduleEndDate.style.border = 'none';
      this.scheduleEndDateRequireMsg.style.display = 'none';
    }

    if (this.selectedTrainingModeValue == null || this.selectedTrainingModeValue == "") {
      this.mode.style.border = '1px solid red';
      this.modeRequiredMsg.style.display = 'block';
    } else {
      this.mode.style.border = 'none';
      this.modeRequiredMsg.style.display = 'none';
    }
  }

  buttonValue: any;
  actualStartDate: any;
  actualEndDate: any;
  expiredOn: any;
  extendFeedbackExpiredOn: any;

  @ViewChild('extendFeedbackPopup', { static: true }) extendFeedbackPopup: TemplateRef<any>;
  visibleExtendFeedbackPopup: MatDialogRef<TemplateRef<any>>;
  dynamicButtonClick(button: any) {
    this.buttonValue = button;
    if (button == "Submit for Approval") {
      this.message.scheduledTrainingsApprover = null;
      this.visibleOperationPopup = this.dialog.open(this.operationPopup, this.operationConfig);
    } else if (button == "Extend Feedback Expiry") {
      this.comments = null;
      this.extendFeedbackExpiredOn = null;
      this.feedbackFormId = this.scheduleTrainingFieldData.feedbackFormId;
      this.visibleExtendFeedbackPopup = this.dialog.open(this.extendFeedbackPopup, this.initiateFeedbackPopupConfig);
    } else if (button == "Initiate Feedback") {
      if (
        this.scheduleTrainingFieldData.feedbackTemplateId === null ||
        this.scheduleTrainingFieldData.feedbackTemplateId === undefined ||
        this.scheduleTrainingFieldData.feedbackTemplateId === ''
      ) {

        alert('Please select Feedback Template before initiating feedback.');
        return;
      }
      this.performSaveOperation();
      this.expiredOn = null;
      this.feedbackFormId = null;
      this.comments = this.scheduleTrainingFieldData.trainingMode + " - Training " + this.scheduleTrainingFieldData.trainingName + " (Trainer - " + this.scheduleTrainingFieldData.trainerName + ")";
      this.visibleInitiateFeedbackPopup = this.dialog.open(this.initiateFeedbackPopup, this.initiateFeedbackPopupConfig);
    } else if (button == "Approve" || button == "Reject") {
      this.userName = localStorage.getItem("loggedUserName");
      this.password = null;
      this.comments = null;
      this.changetypeAddAndEditPassword = true;
      this.visibleConfirmPopup = this.dialog.open(this.confirmPopup, this.confirmConfig);
    } else if (button == "Save") {
      this.performSaveOperation();
    } else {
      if (this.scheduleTrainingFieldData.actualStartDate != null) {
        this.actualStartDate = this.scheduleTrainingFieldData.actualStartDate;
      }
      if (this.scheduleTrainingFieldData.actualEndDate != null) {
        this.actualEndDate = this.scheduleTrainingFieldData.actualEndDate;
      }
      this.comments = null;
      this.visibleOperationPopup = this.dialog.open(this.operationPopup, this.operationConfig);
    }
  }
  performSaveOperation(onSuccess?: () => void) {
    if (this.scheduleTrainingFieldData.notificationSentOn) {
      this.scheduleTrainingFieldData.notificationSentOn = new Date(this.scheduleTrainingFieldData.notificationSentOn).toISOString();
    }
    if (this.scheduleTrainingFieldData.trainingName == null || this.scheduleTrainingFieldData.trainerId == null ||
      this.scheduleTrainingFieldData.scheduledStartDate == null || this.scheduleTrainingFieldData.scheduledEndDate == null
      || this.selectedTrainingModeValue == null || this.selectedTrainingModeValue == "") {
      this.fieldValidation();
      this.isProcessing = false;
    } else if (this.scheduleTrainingFieldData.scheduledStartDate && this.scheduleTrainingFieldData.scheduledEndDate && (this.scheduleTrainingFieldData.scheduledEndDate <= this.scheduleTrainingFieldData.scheduledStartDate)) {
      alert('Scheduled End Date should be greater then Scheduled Start Date');
      this.isProcessing = false;
    } else if (this.scheduleTrainingFieldData.actualStartDate && this.scheduleTrainingFieldData.actualEndDate && (this.scheduleTrainingFieldData.actualEndDate <= this.scheduleTrainingFieldData.actualStartDate)) {
      alert('Actual End Date should be greater then Actual Start Date');
      this.isProcessing = false;
    } else {
      this.isProcessing = true;
      delete this.scheduleTrainingFieldData.createdOn;
      delete this.scheduleTrainingFieldData.updatedOn;
      delete this.scheduleTrainingFieldData.comments;


      this.scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication = this.scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 ? 'Y' : 'N';
      this.scheduleTrainingFieldData.trainingMode = this.selectedTrainingModeValue;
      this.scheduleTrainingFieldData.approvedBy = this.message.scheduledTrainingsApprover ?? null;
      this.appService.updateScheduledTraining(this.scheduleTrainingFieldData).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;

          if (Response.resultType == 'S') {
            if (this.qmsservice.isSwitchUSerPopupOpened) {
              this.switchuserComponent.saveMethod();
              this.switchuserComponent.cancelSwitchUserPopup();
              this.switchuserComponent.closeConfirmationPopup();
              this.qmsservice.isSwitchUSerPopupOpened = false;
            }
            this.searchMode = 'search';
            this.getInitCall();
            this.appService.getTrainingScheduleUsers(this.trainingShceduleId)
              .subscribe((data: any) => {
                this.scheduleUsersList = data;
                this.setPage(1, 0);
              });
            if (onSuccess) {
              onSuccess();
            }
          }

          // Snackbar Logic
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: Response.resultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  selectedApprovalStatusValue: any;
  comments: any;
  performOperationFunc() {
    if ((this.buttonValue == "Submit for Approval" && !this.message.scheduledTrainingsApprover) ||
      (this.buttonValue == "Mark As Completed" && (this.actualStartDate == null ||
        this.actualEndDate == null)) || (this.buttonValue != "Submit for Approval" && this.buttonValue != "Mark As Completed"
          && (!this.comments || this.comments.toString().trim() === ""))) {
      this.operationValidation();
      return;
    }
    const buttonsRequiringComments = [
      'Reject',
      'Submit for Review',
      'Intimate Trainees',
      'Initiate Assessment',
      'Mark As Cancelled',
      'Re-Schedule',
      'Delete'
    ];
    if (buttonsRequiringComments.includes(this.buttonValue)) {
      if (this.comments == null || this.comments.toString().trim() === "") {
        this.operationValidation();
        return;
      }
    }
    let data = {
      trainingScheduleId: this.scheduleTrainingFieldData.trainingScheduleId,
      status: this.scheduleTrainingFieldData.status,
      buttonValue: this.buttonValue,
      actualStartDate: this.actualStartDate,
      actualEndDate: this.actualEndDate,
      approvedBy: this.message.scheduledTrainingsApprover ?? null,
      approvalStatus: this.selectedApprovalStatusValue,
      comments: this.comments,
    }
    this.isProcessing = true;
    this.appService.performOperationsForTrainingSchedule(data).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.resultType == "S") {
        this.visibleOperationPopup.close();
        this.getInitCall();
        this.refreshGrid();
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: data.resultType == 'S' ? 5000 : undefined,
        data: {
          message: data.result,
          type: data.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: data.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
    })


  }

  cancelPerformFunc() {
    this.visibleOperationPopup.close();
    this.actualStartDate = null;
    this.actualEndDate = null;
  }

  refreshGrid() {
    this.appService.getTrainingScheduleUsers(this.trainingShceduleId)
      .subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.scheduleUsersList = data;
          this.collectionSize = this.scheduleUsersList.length;
          this.pager.totalPages = undefined;
          this.setPage(this.pager.currentPage, 0);
        }, error: (error) => {
        }
      });
  }

  pager: any = {};
  pagedItems: any[];
  pagedItems1: any[];
  pagedItems2: any[];
  makeStickyColumns: any;
  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;
  searchValue: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.scheduleUsersList.length, page, this.perPage, targetpage);
    this.pagedItems = this.scheduleUsersList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    this.userNameListForBulkOperation = [];
    this.userIdListForBulkOperation = [];
    if (e.target.checked == true) {
      this.parentCheckBoxs = true;
      this.scheduleUsersList.forEach((user: any) => user.childCheckBoxs = true);

      this.userIdListForBulkOperation = this.scheduleUsersList.map((user: any) => user.userId);
      this.userNameListForBulkOperation = this.scheduleUsersList.map((user: any) => user.userFullName);
      if (this.userIdListForBulkOperation.length > 0) {
        this.isShowBulkIcons = true;
      } else {
        this.isShowBulkIcons = false;
      }
    } else {
      this.parentCheckBoxs = false;
      this.scheduleUsersList.forEach((user: any) => user.childCheckBoxs = false);
      this.userIdListForBulkOperation = [];
      this.userNameListForBulkOperation = [];
      if (this.userIdListForBulkOperation.length > 0) {
        this.isShowBulkIcons = true;
      } else {
        this.isShowBulkIcons = false;
      }
    }
  }
  parentCheckBoxs: any;
  userIdListForBulkOperation: any = [];
  userNameListForBulkOperation: any = [];
  userIdsForBulkOperation: any = null;
  userNamesForBulkOperation: any = null;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
      this.userIdListForBulkOperation.push(list.userId);
      this.userNameListForBulkOperation.push(list.userFullName);
      if (this.userIdListForBulkOperation.length > 0) {
        this.isShowBulkIcons = true;
      } else {
        this.isShowBulkIcons = false;
      }
      if (this.userIdListForBulkOperation.length == this.scheduleUsersList.length) {
        this.parentCheckBoxs = true;
      }
    } else {
      this.parentCheckBoxs = false;
      list.childCheckBoxs = false;
      this.userIdListForBulkOperation.splice(this.userIdListForBulkOperation.indexOf(list.userId), 1);
      this.userNameListForBulkOperation.splice(this.userNameListForBulkOperation.indexOf(list.userFullName), 1);
      if (this.userIdListForBulkOperation.length > 0) {
        this.isShowBulkIcons = true;
      } else {
        this.isShowBulkIcons = false;
      }
    }
  }

  bulkOperationValue: any;
  performBulkOperation(value: any) {
    this.userIdsForBulkOperation = null;
    this.userNamesForBulkOperation = null;
    this.bulkOperationValue = value;
    for (const userId of this.userIdListForBulkOperation) {
      if (this.userIdsForBulkOperation == null) {
        this.userIdsForBulkOperation = userId;
      } else {
        this.userIdsForBulkOperation = this.userIdsForBulkOperation + "," + userId;
      }
    }

    for (const userName of this.userNameListForBulkOperation) {
      if (this.userNamesForBulkOperation == null) {
        this.userNamesForBulkOperation = userName;
      } else {
        this.userNamesForBulkOperation = this.userNamesForBulkOperation + "," + userName;
      }
    }
    this.visibleBulkOperationPopup = this.dialog.open(this.bulkOperationPopup, this.bulkOperationConfig);

  }

  cancelPerformBulkFunc() {
    this.userIdsForBulkOperation = null;
    this.userNamesForBulkOperation = null;
    this.visibleBulkOperationPopup.close();
  }

  performBulkOperationFunc() {
    let obj: any = {
      trainingScheduleId: this.trainingShceduleId,
      userList: this.userIdsForBulkOperation
    }
    if (this.bulkOperationValue == 'Delete') {
      obj.trainingMode = "DELETE";
    } else if (this.bulkOperationValue == 'Absent') {
      obj.trainingMode = "MARK AS ABSENT";
    } else {
      obj.trainingMode = "MARK AS PRESENT";
    }
    this.isProcessing = true;
    this.appService.handledScheduleUsers(obj).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.resultType == "S") {
        this.isProcessing = true;
        this.visibleBulkOperationPopup.close();
        this.isShowBulkIcons = false;
        this.userNameListForBulkOperation = [];
        this.userIdListForBulkOperation = [];
        this.userIdsForBulkOperation = null;
        this.userNamesForBulkOperation = null;
        this.appService.getTrainingScheduleUsers(this.trainingShceduleId)
          .subscribe((data: any) => {
            this.isProcessing = false;
            this.scheduleUsersList = data;
            this.collectionSize = this.scheduleUsersList.length;
            this.pager.totalPages = undefined;
            this.setPage(1, 0,);

          })
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: data.resultType == 'S' ? 5000 : undefined,
        data: {
          message: data.result,
          type: data.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: data.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
    })
  }

  instructorUser: any;
  instructorUserRequiredMsg: any;
  instructorUserValidation() {
    this.instructorUser = document.getElementById('userNameForInstructor') as HTMLInputElement;
    this.instructorUserRequiredMsg = document.getElementById('userNameForInstructor-required-msg') as HTMLInputElement;

    if (this.userList == null) {
      this.instructorUser.style.border = '1px solid red';
      this.instructorUserRequiredMsg.style.display = 'block';
    } else {
      this.instructorUser.style.border = 'none';
      this.instructorUserRequiredMsg.style.display = 'none';
    }
  }

  addAndEditFunction() {
    if (this.userList == null) {
      this.instructorUserValidation();
    } else {
      let data = {
        userList: this.userList,
        trainingMode: "ADD",
        trainingScheduleId: this.scheduleTrainingFieldData.trainingScheduleId
      }
      this.isProcessing = true;
      this.appService.handledScheduleUsers(data).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.isProcessing = true;
          this.visibleAddAndEditPopup.close();
          this.appService.getTrainingScheduleUsers(this.scheduleTrainingFieldData.trainingScheduleId)
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.scheduleUsersList = data;
              this.collectionSize = this.scheduleUsersList.length;
              this.pager.totalPages = undefined;
              this.setPage(1, 0,);
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: data.resultType == 'S' ? 5000 : undefined,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      })
    }

  }

  approveruser: any;
  actualStartDatecss: any;
  actualEndDatecss: any;
  commentsForOpern: any;
  approveruserRequiredMsg: any;
  actualStartDateRequiredMsg: any;
  actualEndDateRequiredMsg: any;
  commentsForOpernRequiredMsg: any;
  operationValidation() {
    const approverLabel = document.getElementById('approver-label') as HTMLInputElement; // NEW
    this.approveruser = document.getElementById('approver') as HTMLInputElement;
    this.actualStartDatecss = document.getElementById('actualStartDate') as HTMLInputElement;
    this.actualEndDatecss = document.getElementById('actualEndDate') as HTMLInputElement;
    this.commentsForOpern = document.getElementById('commentsForOpern') as HTMLInputElement;
    this.approveruserRequiredMsg = document.getElementById('approver-required-msg') as HTMLInputElement;
    this.actualStartDateRequiredMsg = document.getElementById('actualStartDate-required-msg') as HTMLInputElement;
    this.actualEndDateRequiredMsg = document.getElementById('actualEndDate-required-msg') as HTMLInputElement;
    this.commentsForOpernRequiredMsg = document.getElementById('commentsForOpern-required-msg') as HTMLInputElement;

    const buttonsRequiringComments = [
      'Initiate Feedback',
      'Reject',
      'Submit for Approval',
      'Submit for Review',
      'Intimate Trainees',
      'Initiate Assessment',
      'Mark As Cancelled',
      'Re-Schedule',
      'Delete'
    ];

    if (buttonsRequiringComments.includes(this.buttonValue)) {
      if (this.comments == null || this.comments.trim() === '') {
        if (this.commentsForOpern) this.commentsForOpern.style.border = '1px solid red';
        if (this.commentsForOpernRequiredMsg) this.commentsForOpernRequiredMsg.style.display = 'block';
      } else {
        if (this.commentsForOpern) this.commentsForOpern.style.border = '';
        if (this.commentsForOpernRequiredMsg) this.commentsForOpernRequiredMsg.style.display = 'none';
      }
    } else {
      if (this.commentsForOpern) this.commentsForOpern.style.border = '';
      if (this.commentsForOpernRequiredMsg) this.commentsForOpernRequiredMsg.style.display = 'none';
    }
    if (this.buttonValue == "Submit for Approval") {
      if (this.message.scheduledTrainingsApprover == null) {
        if (this.approveruser) this.approveruser.style.border = '1px solid red';
        if (approverLabel) approverLabel.style.color = 'red';
        if (this.approveruserRequiredMsg) this.approveruserRequiredMsg.style.display = 'block';
      } else {
        if (this.approveruser) this.approveruser.style.border = 'none';
        if (approverLabel) approverLabel.style.color = '';
        if (this.approveruserRequiredMsg) this.approveruserRequiredMsg.style.display = 'none';
      }
    }

    if (this.buttonValue == "Mark As Completed") {
      if (this.actualStartDate == null) {
        this.actualStartDatecss.style.border = '1px solid red';
        this.actualStartDateRequiredMsg.style.display = 'block';
      } else {
        this.actualStartDatecss.style.border = 'none';
        this.actualStartDateRequiredMsg.style.display = 'none';
      }

      if (this.actualEndDate == null) {
        this.actualEndDatecss.style.border = '1px solid red';
        this.actualEndDateRequiredMsg.style.display = 'block';
      } else {
        this.actualEndDatecss.style.border = 'none';
        this.actualEndDateRequiredMsg.style.display = 'none';
      }
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  userName: any;
  password: any;

  status: any;
  pass: any;

  statusRequiredMsg: any;
  passRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.status = document.getElementById('comments') as HTMLInputElement;
    this.pass = document.getElementById('password') as HTMLInputElement;
    this.statusRequiredMsg = document.getElementById('comments-required-msg') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('password-required-msg') as HTMLInputElement;

    const buttonsRequiringComments = [
      'Reject',
      'Initiate Feedback',
      'Intimate Trainees',
      'Approve',
      'Mark As Cancelled',
      'Re-Schedule',
      'Delete'
    ];
    if (buttonsRequiringComments.includes(this.buttonValue)) {
      if (this.comments == null || this.comments.toString().trim() === "") {
        if (this.status) this.status.style.border = '1px solid red';
        if (this.statusRequiredMsg) this.statusRequiredMsg.style.display = 'block';
      } else {
        if (this.status) this.status.style.border = 'none';
        if (this.statusRequiredMsg) this.statusRequiredMsg.style.display = 'none';
      }
    } else {
      if (this.status) this.status.style.border = 'none';
      if (this.statusRequiredMsg) this.statusRequiredMsg.style.display = 'none';
    }
    if (this.buttonValue !== 'Initiate Feedback') {
      if (this.password == null || this.password == "") {
        this.pass.style.border = '1px solid red';
        this.passRequiredMsg.style.display = 'block';
      } else {
        this.pass.style.border = 'none';
        this.passRequiredMsg.style.display = 'none';
      }
    }
    if (this.buttonValue === 'Initiate Feedback') {
      const feedbackDateInput = document.getElementById('feedbackExpiryDate') as HTMLInputElement;
      const feedbackDateMsg = document.getElementById('feedbackExpiryDate-required-msg') as HTMLElement;

      if (this.expiredOn == null) {
        if (feedbackDateInput) feedbackDateInput.style.border = '1px solid red';
        if (feedbackDateMsg) feedbackDateMsg.style.display = 'block';
      } else {
        if (feedbackDateInput) feedbackDateInput.style.border = '';
        if (feedbackDateMsg) feedbackDateMsg.style.display = 'none';
      }
    }
  }

  feedbackFormId: any;
  confirmFuncCall() {
    this.isProcessing = true;
    if (this.comments == null || this.comments == "") {
      this.buttonOperationFieldValidation();
      this.isProcessing = false;
    } else {
      let obj: any = {
        trainingScheduleId: this.scheduleTrainingFieldData.trainingScheduleId,
        status: this.scheduleTrainingFieldData.status,
        buttonValue: this.buttonValue,
        actualStartDate: this.actualStartDate,
        actualEndDate: this.actualEndDate,
        approvedBy: this.message.scheduledTrainingsApprover ?? null,
        comments: this.comments,
        feedbackFormId: this.feedbackFormId
      }
      if (this.buttonValue == "Approve") {
        obj.approvalStatus = "Approved";
      } else if (this.buttonValue == "Reject") {
        obj.approvalStatus = "Rejected";
      }
      this.appService.performOperationsForTrainingSchedule(obj).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          if (this.visibleConfirmPopup != undefined) {
            this.visibleConfirmPopup.close();
          }
          if (this.visibleInitiateFeedbackPopup != undefined) {
            this.visibleInitiateFeedbackPopup.close();
          }
          this.getInitCall();
          this.appService.getTrainingScheduleUsers(this.trainingShceduleId)
            .subscribe((userData: any) => {
              this.isProcessing = false;
              this.scheduleUsersList = userData;
              this.collectionSize = this.scheduleUsersList.length;
              // Refresh pagination view to show updated data
              this.setPage(this.pager.currentPage, 0);
            });
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: data.resultType == 'S' ? 5000 : undefined,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      })
    }
  }

  authEnable(flag: string) {
    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            this.confirmFuncCall();
          }
        },
        error: (error) => {
          this.isProcessing = false;
        }
      });
  }

  confirmFunc() {
    this.isProcessing = true;
    if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("adenabele")
    }
    else if (this.password == null || this.password == "") {
      this.buttonOperationFieldValidation();
      this.isProcessing = false;
    } else {
      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.confirmFuncCall();
        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }
      })
    }
  }

  cancelConfirmFunc() {
    this.visibleConfirmPopup.close();
  }

  confirmInitiateFeedbackFunc() {
    if (this.expiredOn == null || this.comments == null || this.comments.trim() === "") {
      this.buttonOperationFieldValidation();
      return;
    }
    let data = {

      feedbackTemplateId: this.scheduleTrainingFieldData.feedbackTemplateId,
      feedbackFormDescription: this.comments,
      isActive: "Y",
      effectiveFrom: new Date(),
      expiredOn: this.expiredOn
    }
    this.appService.addFeedbackForm(data).subscribe((data: any) => {
      if (data.resultType == "S") {
        this.isProcessing = false;
        this.feedbackFormId = data.feedbackFormId;
        this.confirmFuncCall();
      } else {
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });

        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }

    })
  }

  cancelInitiateFeedbackFunc() {
    this.visibleInitiateFeedbackPopup.close();
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  openAddPopupForUser() {
    this.userList = null;
    this.userNameList = null;
    this.selectedUserIdList = [];
    this.selectedUserNameList = [];
    this.searchVal = "User";
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.userList = null;
    this.userNameList = null;
    this.selectedUserIdList = [];
    this.selectedUserNameList = [];
    this.popupDataTitle.title = "Search User";
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);
  }
  todayDate = new Date();
  minEndDate = new Date();
  setVal(event: any) {
    this.scheduleTrainingFieldData.scheduledStartDate = new Date(event);
    this.minEndDate = event;
  }

  title: any;
  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  openswitchuser(value: any, data: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = this.approverDropdown;
    this.message.submodule = "Instructor Training";
    this.message.switchuserRole = value;
    this.scheduleTrainingFieldData = data;
    this.title = 'Switch ' + value;
    this.qmsservice.moduleName = "Instructor Training";
    let usersValues = this.approverDropdown.filter((x: any) => x.valueExp === data.approvedBy);
    if (usersValues.length != 0) {
      this.message.currentSwitchuser = this.message.switchedUser = this.message.scheduledTrainingsApprover;
    }
    this.message.switchUserCurrentValue = this.message.scheduledTrainingsApprover;
    this.message.activityId = this.scheduleTrainingFieldData.trainingScheduleId;
    this.message.version = 0;
    this.switchuserComponent.openswitchuser(value, "Instructor Training");
  };

  onChildValueEmitted() {
    this.message.scheduledTrainingsApprover = this.message.switchedUser ? this.message.switchedUser : null;
    this.dynamicButtonClick("Save");
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  openReportDup(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_USER_TRAININGS_VW_JOIN_ONEQMS_USERS_VW";

    if (this.scheduleTrainingFieldData.feedbackTemplateId) {
      this.excelPdf.columnList_DB = "TMS_USER_TRAININGS_VW.USER_NAME AS USER_NAME, "
        + "TMS_USER_TRAININGS_VW.USR_FULLNAME AS USR_FULLNAME, "
        + "TMS_USER_TRAININGS_VW.STATUS AS TRAINING_STATUS, "
        + "ONEQMS_USERS_VW.DEPARTMENT AS DEPARTMENT, "
        + "ONEQMS_FEEDBACK_FORM_USERS.STATUS AS FEEDBACK_STATUS, "
        + "ONEQMS_FEEDBACK_FORM_USERS.FINAL_SCORE AS FINAL_SCORE, "
        + "TO_CHAR(ONEQMS_FEEDBACK_FORM_USERS.FEEDBACK_COMPLETED_ON, 'DD-MON-YYYY HH24:MI:SS') AS FEEDBACK_COMPLETED_ON, "
        + "TO_CHAR(ONEQMS_FEEDBACK_FORM_USERS.EXPIRED_ON, 'DD-MON-YYYY HH24:MI:SS') AS EXPIRED_ON, "
        + "ONEQMS_FEEDBACK_FORM_USERS.INITIATED_BY_USER AS INITIATED_BY_USER, "
        + "TO_CHAR(ONEQMS_FEEDBACK_FORM_USERS.INITIATED_ON, 'DD-MON-YYYY HH24:MI:SS') AS INITIATED_ON";

      this.excelPdf.columnList_Report = "User Name,User Full Name,Status,Department," +
        "Feedback Status,Feedback Score,Completed On,Expired On,Initiated By,Initiated On";
    } else {
      this.excelPdf.columnList_DB = "TMS_USER_TRAININGS_VW.USER_NAME,TMS_USER_TRAININGS_VW.USR_FULLNAME,TMS_USER_TRAININGS_VW.STATUS,ONEQMS_USERS_VW.DEPARTMENT";
      this.excelPdf.columnList_Report = "User Name,User Full Name,Status,Department";
    }

    this.excelPdf.whereClause_Report = (this.scheduleTrainingFieldData.feedbackTemplateId ?
      ' WHERE TMS_USER_TRAININGS_VW.TRAINING_SCHEDULE_ID = ' :
      ' WHERE TRAINING_SCHEDULE_ID = ') + this.trainingShceduleId;

    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Instructor Training User Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }
  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_SCHEDULED_TRAINING_USERS_VW_SP_Report";

    if (this.scheduleTrainingFieldData.feedbackTemplateId) {
      this.excelPdf.columnList_DB = 'USER_NAME,USR_FULLNAME,STATUS,DEPARTMENT,' +
        'FEEDBACK_STATUS,FINAL_SCORE,FEEDBACK_COMPLETED_ON,EXPIRED_ON,INITIATED_BY_USER,INITIATED_ON';

      this.excelPdf.columnList_Report = "User Name,User Full Name,Status,Department," +
        "Feedback Status,Feedback Score,Feedback Completed On,Feedback Expired On,Feedback Initiated By,Feedback Initiated On";
    } else {
      this.excelPdf.columnList_DB = 'USER_NAME,USR_FULLNAME,STATUS,DEPARTMENT';
      this.excelPdf.columnList_Report = "User Name,User Full Name,Status,Department";
    }

    this.excelPdf.whereClause_Report = ' AND TRN.TRAINING_SCHEDULE_ID= ' + this.trainingShceduleId;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Instructor Training User Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }


  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: 'TMS_SCHEDULED_TRAININGS_GRID_VW',
      moduleName: null,
      gridName: 'SCHEDULED_TRAININGS',
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }


  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.scheduleUsersList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.scheduleUsersList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  feedbackQuestionsList: any;
  openDetailInPopup(event: any, user: any) {
    event.preventDefault();
    this.isProcessing = true;
    this.appService.getFeedbackTemplateQuestionListForILT(
      this.scheduleTrainingFieldData.feedbackTemplateId, this.scheduleTrainingFieldData.feedbackFormId, user.userId).subscribe((data: any) => {
        this.isProcessing = false;
        this.feedbackQuestionsList = data;
        for (let question of this.feedbackQuestionsList) {
          question.selectedFlexifieldValue = "";

          if (question.fieldTypeCode === "Drop Down" ||
            question.fieldTypeCode === "Check Box" ||
            question.fieldTypeCode === "Radio Button") {

            if (question.fieldLovValues != null) {
              question.dropDownValues = question.fieldLovValues.split(",");
            }
          }
        }

      })
    this.visibleFeedbackDetailPopup = this.dialog.open(this.feedbackDetailPopup, this.feedbackDetailPopupConfig);
  }

  fieldsSearchTxt: string = '';
  onFlexifieldSelect(item: any, data: any) {
    data.fieldDefaultValue = item.valueExp;
  }

  radioBoxChecked(data: any, event: any, val: any) {
    data.fieldDefaultValue = val;
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  cancelFeedbackFunc() {
    this.visibleFeedbackDetailPopup.close();
  }

  reInitiateFeedbackData: any;
  ReinitateFeedbackFunc(data: any) {
    this.reInitiateFeedbackData = data;
    this.comments = null;
    this.expiredOn = null;
    this.visibleReInitiateFeedbackPopup = this.dialog.open(this.reInitiateFeedbackPopup, this.reInitiateFeedbackPopupConfig)
  }

  cancelReinitiateFeedbackFunc() {
    this.visibleReInitiateFeedbackPopup.close();
  }

  performReinitiateFunc() {
    this.isProcessing = true;
    let data = {
      feedbackFormUserId: this.reInitiateFeedbackData.feedbackFormUserId
    }
    this.appService.reinitiateFeedbackForUser(data).subscribe((data: any) => {
      if (data.resultType == "S") {
        this.visibleReInitiateFeedbackPopup.close();
        this.appService.getTrainingScheduleUsers(this.trainingShceduleId)
          .subscribe((data: any) => {
            this.isProcessing = false;
            this.scheduleUsersList = data;
            this.collectionSize = this.scheduleUsersList.length;
            this.pager.totalPages = undefined;
            this.setPage(1, 0,);

          })
      }
      this.isProcessing = false;

      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: data.result,
          type: data.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: data.resultType == 'S' ? 'Success' : 'Error',
      });

      sb.onAction().subscribe(() => {
        sb.dismiss();
      });

      this.isProcessing = false;

    })
  }




  @ViewChild('datePicker', { static: false }) datepicker!: BsDatepickerDirective;
  onDateChange(datepicker: BsDatepickerDirective): void {
    setTimeout(() => {
      datepicker.show();
    }, 0);
  }

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('individualReportPopup', { static: true }) individualReportPopup: TemplateRef<any>;
  visibleIndividualReportPopup: MatDialogRef<TemplateRef<any>>;

  tableReportavgQuestionScroeList: any = [];
  tableReportinduScroeList: any = [];
  avgFinalScroeList: any = [];
  avgFinalScroe: any;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };
  reportPopupConfig1 = {
    width: '100%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };
  openReportPopup() {
    this.isProcessing = true;
    forkJoin([
      this.appService.getAvgFinalScroe(this.scheduleTrainingFieldData.feedbackTemplateId, this.scheduleTrainingFieldData.feedbackFormId),
      this.appService.getAvgAvgQuestionScroe(this.scheduleTrainingFieldData.feedbackTemplateId, this.scheduleTrainingFieldData.feedbackFormId)
    ]).subscribe(([avgFinalScroe, avgQuestionScroe]) => {
      this.avgFinalScroeList = avgFinalScroe;
      this.avgFinalScroe = this.avgFinalScroeList[0].fieldScore;
      this.tableReportavgQuestionScroeList = avgQuestionScroe;
      this.calculateTotalPages = this.collectionSize / this.perPage;
      this.pager.totalPages = undefined;
      this.collectionSize = this.tableReportavgQuestionScroeList.length;
      this.totalPages = Math.ceil(this.tableReportavgQuestionScroeList.length / this.itemsPerPage);
      this.setPage1(1, 0);
      this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
      this.isProcessing = false;
    })
    this.isSaveReport = false;
  }
  selectedRow: number | null = null;
  selectedquestionId: number | null = null;
  openInduReportPopup(index: number, val: any) {
    this.isProcessing = true;
    this.selectedRow = index;
    this.selectedquestionId = val.questionId;
    forkJoin([
      this.appService.getAvgInduQuestionScroe(this.scheduleTrainingFieldData.feedbackTemplateId, this.scheduleTrainingFieldData.feedbackFormId, val.questionId)
    ]).subscribe(([induScroe]) => {
      this.tableReportinduScroeList = induScroe;
      this.calculateTotalPages = this.collectionSize / this.perPage;
      this.pager.totalPages = undefined;
      this.collectionSize = this.tableReportinduScroeList.length;
      this.totalPages = Math.ceil(this.tableReportinduScroeList.length / this.itemsPerPage);
      this.setPage2(1, 0);
      this.isProcessing = false;
      this.individualReport = true;
    })
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportavgQuestionScroeList.length, page, this.perPage, targetpage);
    if (this.tableReportavgQuestionScroeList.length > 0) {
      this.pagedItems2 = this.tableReportavgQuestionScroeList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportinduScroeList.length, page, this.perPage, targetpage);
    if (this.tableReportinduScroeList.length > 0) {
      this.pagedItems1 = this.tableReportinduScroeList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }

  refreshCollectionSize() {

    this.collectionSize = this.pagedItems2.length;
  }
  refreshCollectionSize1() {

    this.collectionSize = this.pagedItems.length;
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
    this.refreshCollectionSize1();
    this.individualReport = false;
  }
  cancelIndividualReportPopupFunction() {
    this.visibleIndividualReportPopup.close();
    this.refreshCollectionSize();
  }


  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportavgQuestionScroeList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportavgQuestionScroeList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportinduScroeList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportinduScroeList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];

  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};

  isSaveReport: boolean = false;
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  reportName: any;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  @ViewChild('pdf') pdf: MatSelect;
  pdfColumnSelection = false;
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfColumnSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  selectedReportLogoValue: any = null;
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'pdf-select-all');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }
  toggleAllSelection1(value: any) {
    if (value == 'pdf') {
      if (this.pdfColumnSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  typeVals: any;
  openExcelPdfReportPopup(item: any, typeVals: any) {
    this.typeVals = typeVals;
    if (this.typeVals == '1') {
      this.columnList = "Question Code,Question,Possible Score,Feedback User Count,Avg Field Score";
      this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));

    } else if (this.typeVals == '2') {
      this.columnList = "Question Code,Question,Possible Options,Possible Score,User Name,Field Value,Field Score";
      this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));

    }
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.pdfColumnSelection = false;

  }
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }

  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let data2;
      let reModule = '';
      let wherVal = '';
      tname = "ONEQMS_FEEDBACK_FORM_USER_QUESTIONS_VW";
      if (this.typeVals == '1') {
        colList = "QUESTION_CODE,QUESTION,POSSIBLE_SCORES,FEEDBACK_USER_CNT,FIELD_SCORE";
        fieldList = "Question Code,Question,Possible Score,Feedback User Count,Avg Field Score";
        wherVal = " WHERE ORG_ID =" + this.message.getOrgId() + " AND TEMPLATE_ID =" + this.scheduleTrainingFieldData.feedbackTemplateId + " AND FEEDBACK_FORM_ID =" + this.scheduleTrainingFieldData.feedbackFormId;
        reModule = "1Feed";
      } else if (this.typeVals == '2') {
        colList = "QUESTION_CODE,QUESTION,POSSIBLE_OPTIONS,POSSIBLE_SCORES,USER_NAME,FIELD_VALUE,FIELD_SCORE";
        fieldList = "Question Code,Question,Possible Options,Possible Score,User Name,Field Value,Field Score";
        reModule = "2Feed";
        wherVal = " WHERE ORG_ID =" + this.message.getOrgId() + " AND TEMPLATE_ID =" + this.scheduleTrainingFieldData.feedbackTemplateId + " AND FEEDBACK_FORM_ID =" + this.scheduleTrainingFieldData.feedbackFormId + " AND QUESTION_ID =" + this.selectedquestionId;

      }

      console.log(value, "--------------------");
      const data = {

        groupId: this.qmsservice.selectedGroup
      }
      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: this.statusCodeValue,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        logoId: 0,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName,
        currentStatus: "NA",
        groupName: "",
        reModule: reModule,
        wherVal: wherVal
      }
      this.reportObj = { ...data1, ...data };
      debugger;
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(timestamp)).replaceAll(/[, ]/g, (match) => match === ',' ? '' : '_');

      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = "Feedback User Question Report" + `${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: "Report", columns: [],
          "informationTab": {
            "Report Name": "Feedback User Question Report",
            "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName);
      } else {
        const pdfData = {
          ...this.reportObj, "footer": this.selectedReportFooter, title: "Feedback User Question Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName);
      }
    }
  }
  selectedFeedbackTemplateName: any;
  openReportPopupAttanace(value: any) {
    this.selectedFeedbackTemplateName = "";
    let tname = "TMS_SCHEDULED_TRAINING_USERS_VW_SP_Report";
    let colList = "USER_NAME,USER_FULLNAME,STATUS,DEPARTMENT,FEEDBACK_STATUS,FEEDBACK_SCORE,FEEDBACK_COMPLETED_ON";
    let fieldList = "User Name,User Fullname,Status,Department,Feedback Status,Feedback Score,Feedback Completed On";
    this.columnList = "User Name,User Fullname,Status,Department,Feedback Status,Feedback Score,Feedback Completed On";
    const data = {

    }
    const data1: any = {
      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: "FEEDBACK_COMPLETED_ON,EXPIRED_ON,INITIATED_ON",
      groupId: this.qmsservice.selectedActivityGroupId,
      trainingShceduleId: this.trainingShceduleId.toString(),
      logoId: 0,
      isSaveRep: this.isSaveReport ? 'Y' : 'N',
      reportName: this.reportName,
      currentStatus: "NA",
      groupName: "",
      reModule: "ilt",
      wherVal: ' AND TRN.TRAINING_SCHEDULE_ID= ' + this.trainingShceduleId,
      pdfPageSize: this.excelPdf.pdfPageSize
    }

    if (this.feedbackTemplateList) {
      for (const template of this.feedbackTemplateList) {
        if (template.templateId == this.scheduleTrainingFieldData.feedbackTemplateId) {
          this.selectedFeedbackTemplateName = template.templateName;
          break;
        }
      }
    }
    console.log("this.selectedFeedbackTemplateName=" + this.selectedFeedbackTemplateName);
    this.reportObj = {};
    const timestamp = Date.now();
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit', month: 'short', year: 'numeric',
    }).format(new Date(timestamp)).replaceAll(/[, ]/g, (match) => match === ',' ? '' : '_');
    let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
    const fileName = "ILT_" + this.scheduleTrainingFieldData.trainingName + `_${formattedDate}.${fileType}`;
    const pdfData = {
      ...data1, ...data, "footer": this.selectedReportFooter,
      "trInformation": {
        "Training Name": this.scheduleTrainingFieldData.trainingName,
        "Version": this.scheduleTrainingFieldData.version,
        "Status": this.scheduleTrainingFieldData.status,
        "Trainer Name": this.scheduleTrainingFieldData.trainerName,
        "Scheduled Start Date": this.scheduleTrainingFieldData.scheduledStartDate ?? null,
        "Scheduled End Date": this.scheduleTrainingFieldData.scheduledEndDate ?? null,
        "Start Date": this.scheduleTrainingFieldData.actualStartDate ?? null,
        "End Date": this.scheduleTrainingFieldData.actualEndDate ?? null,
        "Allowed Failed Attempts": this.scheduleTrainingFieldData.allowedFailedAttempts,
        "Allowed Failed Attempts After Unlock": this.scheduleTrainingFieldData.allowedFailedAttemptsAfterUnlock,
        "Max Allowed Failed Attempts": this.scheduleTrainingFieldData.maxAllowedFailedAttempts,
        "Training Details": this.scheduleTrainingFieldData.trainingDetails,
        "Training Mode Details": this.scheduleTrainingFieldData.trainingModeDetails,
        "Allow Users To Take Assessment At Application": this.scheduleTrainingFieldData.allowUsersToTakeAssessmentAtApplication1 ? "Yes" : "No",
        "Duration In Mins": this.scheduleTrainingFieldData.durationInMins,
        "Notify Before N Days": this.scheduleTrainingFieldData.notifyBeforeNDays,
        "Approval Requested On": this.scheduleTrainingFieldData.approvalRequestedOn ?? null,
        "Approved On": this.scheduleTrainingFieldData.approvedOn ?? null,
        "Approved By": this.scheduleTrainingFieldData.approvedByUser,
        "schedule Training Id": this.trainingShceduleId,
        "Feedback Expired On": this.datePipe.transform(this.scheduleTrainingFieldData.expiredOn, 'dd-MMM-yyyy HH:mm:ss'),
        "Feedback Initiated By": this.scheduleTrainingFieldData.initiatedByUser,
        "Feedback Initiated On": this.datePipe.transform(this.scheduleTrainingFieldData.initiatedOn, this.dateFormat + ' HH:mm:ss'),
        "Feedback Template Name": this.selectedFeedbackTemplateName,
      }, title: "ILT_" + this.scheduleTrainingFieldData.trainingName + `_${formattedDate}`, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
    }
    this.appService.downloadPdfForILT(pdfData, fileName);
  }


  //footer code

  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    }
    );
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("TRN")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }

  disableDateFields(): boolean {
    const status = this.scheduleTrainingFieldData?.status;
    const disableStatuses = [
      'Scheduled',
      'Assessment Inprogress',
      'Completed'
    ];

    return disableStatuses.includes(status) || !this.saveButtonForScheduleTraining;
  }

  canShowSwitchUser(): boolean {
    if (!this.message.showSwitchUser) {
      return false;
    }
    const status = this.scheduleTrainingFieldData?.status;

    const forbiddenStatuses = [
      'Draft',
      'Approval Rejected',
      'Scheduled',
      'Assessment Inprogress',
      'Completed'
    ];

    return !forbiddenStatuses.includes(status);
  }

  cancelExtendFeedbackFunc() {
    if (this.visibleExtendFeedbackPopup) {
      this.visibleExtendFeedbackPopup.close();
    }
    this.extendFeedbackExpiredOn = null;
    this.comments = null;
  }

  confirmExtendFeedbackFunc() {
    // Validation
    const dateField = document.getElementById('extendDate');
    const commentField = document.getElementById('extendComments');
    const dateMsg = document.getElementById('extendDate-required-msg');
    const commentMsg = document.getElementById('extendComments-required-msg');

    let isValid = true;

    if (this.extendFeedbackExpiredOn) {
      if (dateField) dateField.style.border = '';
      if (dateMsg) dateMsg.style.display = 'none';
    } else {
      if (dateField) dateField.style.border = '1px solid red';
      if (dateMsg) dateMsg.style.display = 'block';
      isValid = false;
    }

    if (!this.comments || this.comments.trim() === '') {
      if (commentField) commentField.style.border = '1px solid red';
      if (commentMsg) commentMsg.style.display = 'block';
      isValid = false;
    } else {
      if (commentField) commentField.style.border = '';
      if (commentMsg) commentMsg.style.display = 'none';
    }

    if (!isValid) return;

    this.isProcessing = true;

    // Construct Payload
    let data = {
      trainingScheduleId: this.scheduleTrainingFieldData.trainingScheduleId,
      // status: this.scheduleTrainingFieldData.status,
      buttonValue: this.buttonValue,
      approvedBy: this.message.scheduledTrainingsApprover ?? null,
      comments: this.comments,
      extendFeedbackExpiredOn: this.extendFeedbackExpiredOn,
      feedbackFormId: this.feedbackFormId
    };

    // Call the API
    this.appService.performOperationsForTrainingSchedule(data).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleExtendFeedbackPopup.close();
          this.getInitCall();
          this.refreshGrid();
        }

        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: data.resultType == 'S' ? 5000 : undefined,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });

        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, error: (error) => {
        this.isProcessing = false;
      }
    });
  }
  isEditorEnabled(): boolean {
    const status = this.scheduleTrainingFieldData?.status;
    return (status === 'Scheduled' || status === 'Draft') && this.saveButtonForScheduleTraining;
  }

  public getReInitiateButton(trainerId: any): boolean {
    return +trainerId == +this.message.getUserId()!;
  }
  public isCurrentTrainer(): boolean {
    const currentUserId = this.message.getUserId();
    const trainerId = this.scheduleTrainingFieldData?.trainerId;

    if (!currentUserId || !trainerId) {
      return false;
    }

    return +currentUserId === +trainerId;
  }

  previousExpiredOn: Date | null = null;

  // Add this method to handle the date/time change
  onExpiryDateChange(date: Date) {
    if (date) {
      const now = new Date();

      // 1. Check if the time part matches the current system time exactly (down to the second).
      // If it does, it means ngx-bootstrap auto-filled it when you clicked the date.
      const isAutoFilledTime = (
        date.getHours() === now.getHours() &&
        date.getMinutes() === now.getMinutes() &&
        date.getSeconds() === now.getSeconds()
      );

      // 2. Check if the DATE part actually changed from the previous value.
      // (If only the time changed, it means you used the timepicker, so we shouldn't reset it).
      const isDateChanged = !this.previousExpiredOn ||
        this.previousExpiredOn.getDate() !== date.getDate() ||
        this.previousExpiredOn.getMonth() !== date.getMonth() ||
        this.previousExpiredOn.getFullYear() !== date.getFullYear();

      // 3. If it's a NEW date AND the time is exactly the current system time, reset it to 00:00:00
      if (isDateChanged && isAutoFilledTime) {
        date.setHours(0, 0, 0, 0);
        this.expiredOn = new Date(date); // Update the model with the corrected time
      }

      // Update the tracker for the next change
      this.previousExpiredOn = new Date(date);
    }
  }

}
